module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/bg_02-f08d9aabc2e36cd9069a09b81b9ffcd7.jpg";